import axios from 'axios';
import {apiBaseUrl} from "../../../helpers/UrlHelper";
import {loginToken, logOut} from '../../../helpers/LocalStorageHelper'
import {handleError} from '../../../helpers/ErrorHelper'

function _success(success) {
    return {type: 'GET_ORGANIZATION_USER_SUCCESS', success};
}

function _error(error) {
    return {type: 'GET_ORGANIZATION_USER_ERROR', error};
}

function _processing(processing) {
    return {type: 'GET_ORGANIZATION_USER_PROCESSING', processing};
}

function getOrganizationUser(organization_id = null, customer_id) {
    return (dispatch, getState) => {
        let {organizationDashboard} = getState()
        let org_id = organization_id || organizationDashboard.data.organization_id;

        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));

        const request = axios({

            url: apiBaseUrl(`admin/organizations/${org_id}/customers/${customer_id}`),
            method: "get",
            dataType: 'json',
            headers: {'Authorization': 'Bearer ' + loginToken()}
        })
            .then(function (res) {
                // let role = res.data.data.roles[0].name;
                // if(role === 'customer') {
                //   logOut()
                // }else{
                dispatch(_success(res.data.data));
                dispatch(_processing(false));
                // }
            }).catch(function (error) {

                if (error && error.response &&
                    error.response.status === 401) {
                    logOut()
                } else {
                    handleError(error)
                    dispatch(_error(error));
                    dispatch(_processing(false));
                }
            });

        return {
            type: 'GET_ORGANIZATION_USER_SUCCESS',
            payload: request
        }
    }
}


export default getOrganizationUser;